module.exports = new __parcel__URL__("../bird.7a8cad65.jpg").toString();